import { useState } from "react";
import { MailCheck } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useT } from "../lib/i18n";

export const ForgotForm = ({ onBack, testPrefix = "forgot" }) => {
  const { t, lang } = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, lang });
      setSent(true);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div data-testid={`${testPrefix}-panel`} className="space-y-4">
      <p className="text-sm text-[#A8B3C4]">{t("forgot.desc")}</p>
      {sent ? (
        <p data-testid={`${testPrefix}-sent`} className="flex gap-3 text-sm text-white border border-[#1FD1FF]/40 bg-[#1FD1FF]/10 p-4"><MailCheck className="w-5 h-5 text-[#1FD1FF] shrink-0" />{t("forgot.sent")}</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")} data-testid={`${testPrefix}-email-input`}
            className="w-full bg-transparent border border-white/15 px-3 py-3 text-sm focus:outline-none focus:border-[#1FD1FF]" />
          {error && <p className="text-sm text-[#FCA5A5]" data-testid={`${testPrefix}-error`}>{error}</p>}
          <button data-testid={`${testPrefix}-submit`} disabled={busy} className="w-full py-3.5 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest hover:bg-white transition-colors disabled:opacity-60">
            {busy ? t("auth.wait") : t("forgot.send")}
          </button>
        </form>
      )}
      <button type="button" data-testid={`${testPrefix}-back`} onClick={onBack} className="font-mono text-xs text-[#A8B3C4] hover:text-[#1FD1FF] transition-colors">{t("forgot.back")}</button>
    </div>
  );
};
